<template>
  <div class="text-xl font-medium tracking-wide select-none">Module Title</div>
</template>

<script>
export default {

}
</script>

<style>

</style>
